var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rod-value__percentage",class:_vm.rodCls},[_vm._v("\n  "+_vm._s(_vm.formattedRod)+"\n  "),(_vm.showMoney)?_c('span',{staticClass:"rod-value__money"},[_vm._v("("+_vm._s(_vm.formattedGrowthMoney)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }